var httpStatusCode = /* @__PURE__ */ ((httpStatusCode2) => {
  httpStatusCode2[httpStatusCode2["ok"] = 200] = "ok";
  httpStatusCode2[httpStatusCode2["movedPermanently"] = 301] = "movedPermanently";
  httpStatusCode2[httpStatusCode2["movedTemporarily"] = 302] = "movedTemporarily";
  httpStatusCode2[httpStatusCode2["notModified"] = 304] = "notModified";
  httpStatusCode2[httpStatusCode2["multipleChoices"] = 300] = "multipleChoices";
  httpStatusCode2[httpStatusCode2["badRequest"] = 400] = "badRequest";
  httpStatusCode2[httpStatusCode2["unAuthorized"] = 401] = "unAuthorized";
  httpStatusCode2[httpStatusCode2["forbidden"] = 403] = "forbidden";
  httpStatusCode2[httpStatusCode2["notFound"] = 404] = "notFound";
  httpStatusCode2[httpStatusCode2["methodNotAllowed"] = 405] = "methodNotAllowed";
  httpStatusCode2[httpStatusCode2["requestTimeout"] = 408] = "requestTimeout";
  httpStatusCode2[httpStatusCode2["unavaukableForLegalReasons"] = 451] = "unavaukableForLegalReasons";
  httpStatusCode2[httpStatusCode2["serverError"] = 500] = "serverError";
  httpStatusCode2[httpStatusCode2["badGateway"] = 502] = "badGateway";
  httpStatusCode2[httpStatusCode2["gatewayTimeout"] = 504] = "gatewayTimeout";
  return httpStatusCode2;
})(httpStatusCode || {});

export { httpStatusCode as default };
